module.exports = __webpack_public_path__ + "img/code2.0a217e65.png";